export enum LoginIndex {
  email = 0,
  firstTimeOtp = 1,
  enterPassword = 2,
  setPassword = 3,
  reEnterPassword = 4,
  passwordChanged = 5,
  login = 6,
  welcome = 7,
  tokenTransfer = 8,
  checkTransfer = 9,
  enterOtpForLogin = 10
}

export interface IUserDetail {
  displayName?: string;
  email?: string;
  address?: string;
  access_token?: string;
  otpGuardedActions?: string[];
  twoFactorAuthenticationEnabled?: boolean;
  conversation_id?: string;
}

export class UserDetail implements IUserDetail {
  displayName = '';
  email = '';
  address = '';
  access_token = '';
  otpGuardedActions: string[] = [];
  twoFactorAuthenticationEnabled = false;
  conversation_id?: string;
}
